import React from 'react';

export const OverviewIcon = ({
    className = '',
    height = 18,
    width = 18,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 10H7C7.55 10 8 9.55 8 9V1C8 0.45 7.55 0 7 0H1C0.45 0 0 0.45 0 1V9C0 9.55 0.45 10 1 10ZM1 18H7C7.55 18 8 17.55 8 17V13C8 12.45 7.55 12 7 12H1C0.45 12 0 12.45 0 13V17C0 17.55 0.45 18 1 18ZM11 18H17C17.55 18 18 17.55 18 17V9C18 8.45 17.55 8 17 8H11C10.45 8 10 8.45 10 9V17C10 17.55 10.45 18 11 18ZM10 1V5C10 5.55 10.45 6 11 6H17C17.55 6 18 5.55 18 5V1C18 0.45 17.55 0 17 0H11C10.45 0 10 0.45 10 1Z"
                fill={fill}
            />
        </svg>
    );
};

export const RepositoriesIcon = ({
    className = '',
    height = 20,
    width = 20,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.84333 6.855C3.02778 8.038 3.72 10.062 6.27333 10.934C8.88889 11.829 8.88889 12.534 8.88889 13V13.163C7.28889 13.597 6.11111 14.92 6.11111 16.5C6.11111 18.43 7.85556 20 10 20C12.1444 20 13.8889 18.43 13.8889 16.5C13.8889 14.92 12.7111 13.597 11.1111 13.163V13C11.1111 12.534 11.1111 11.829 13.7267 10.935C16.28 10.063 16.9722 8.039 17.1567 6.856C18.7911 6.441 20 5.102 20 3.5C20 1.57 18.2556 0 16.1111 0C13.9667 0 12.2222 1.57 12.2222 3.5C12.2222 5.052 13.3578 6.355 14.9156 6.813C14.7533 7.548 14.2878 8.604 12.94 9.065C11.6156 9.517 10.6589 10.018 10 10.601C9.34111 10.018 8.38556 9.517 7.06 9.065C5.71222 8.604 5.24556 7.548 5.08444 6.813C6.64222 6.355 7.77778 5.052 7.77778 3.5C7.77778 1.57 6.03333 0 3.88889 0C1.74444 0 0 1.57 0 3.5C0 5.102 1.20889 6.441 2.84333 6.855ZM16.1111 2C17.03 2 17.7778 2.673 17.7778 3.5C17.7778 4.327 17.03 5 16.1111 5C15.1922 5 14.4444 4.327 14.4444 3.5C14.4444 2.673 15.1922 2 16.1111 2ZM11.6667 16.5C11.6667 17.327 10.9189 18 10 18C9.08111 18 8.33333 17.327 8.33333 16.5C8.33333 15.673 9.08111 15 10 15C10.9189 15 11.6667 15.673 11.6667 16.5ZM3.88889 2C4.80778 2 5.55556 2.673 5.55556 3.5C5.55556 4.327 4.80778 5 3.88889 5C2.97 5 2.22222 4.327 2.22222 3.5C2.22222 2.673 2.97 2 3.88889 2Z"
                fill={fill}
            />
        </svg>
    );
};

export const KudosIcon = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.0388 6.43938C16.8378 6.09223 16.5544 5.79998 16.2135 5.5885C15.8727 5.37701 15.485 5.25281 15.0847 5.22688C14.6844 5.20095 14.2839 5.2741 13.9186 5.43985C13.5534 5.6056 13.2346 5.85884 12.9905 6.17716L11.6787 3.90494C11.4734 3.54906 11.1814 3.25086 10.83 3.03808C10.4785 2.8253 10.079 2.70485 9.66848 2.68792C9.25799 2.67098 8.84988 2.75812 8.48209 2.94124C8.11431 3.12435 7.7988 3.39749 7.56491 3.73525C7.19143 3.38493 6.71717 3.16102 6.20935 3.09525C5.70152 3.02948 5.18587 3.12519 4.73547 3.36882C4.28507 3.61244 3.92275 3.99163 3.69987 4.45264C3.47698 4.91366 3.40483 5.43313 3.49363 5.93744C3.1229 6.02378 2.77755 6.19576 2.48525 6.43959C2.19295 6.68342 1.96183 6.99232 1.8104 7.34155C1.65897 7.69078 1.59144 8.07062 1.61323 8.45065C1.63502 8.83067 1.74552 9.20031 1.93588 9.52994L2.12263 9.85347C1.7249 9.90572 1.34619 10.0552 1.02 10.2887C0.693811 10.5222 0.430205 10.8325 0.252509 11.1921C0.0748135 11.5517 -0.0114929 11.9496 0.00122754 12.3506C0.013948 12.7515 0.125303 13.1431 0.325439 13.4908L3.79419 19.4988C4.50523 20.7303 5.55169 21.7342 6.81155 22.3936C8.07141 23.053 9.49275 23.3406 10.9099 23.223C12.327 23.1054 13.6814 22.5873 14.8153 21.7293C15.9492 20.8712 16.8159 19.7085 17.3142 18.3767C18.5309 17.2163 19.3223 15.6807 19.5614 14.0164C19.8005 12.3522 19.4734 10.6559 18.6327 9.19985L17.0388 6.43938ZM9.09875 4.31181C9.31417 4.18777 9.56999 4.15423 9.8101 4.21856C10.0502 4.28288 10.255 4.43982 10.3796 4.65494L12.3811 8.12163C11.8888 8.26961 11.4555 8.56857 11.1424 8.97625L9.83047 6.70403C9.60126 6.30636 9.26378 5.98198 8.85734 5.76869L8.75572 5.59244C8.63171 5.37705 8.59819 5.12126 8.66251 4.88119C8.72684 4.64111 8.88375 4.43635 9.09884 4.31181H9.09875ZM5.426 4.70031C5.64139 4.5763 5.89718 4.54278 6.13725 4.60711C6.37733 4.67143 6.58209 4.82835 6.70663 5.04344L7.02097 5.58794C6.4908 5.74593 6.03042 6.08013 5.71597 6.53528C5.55668 6.38587 5.37794 6.25866 5.18459 6.1571L5.08288 5.98103C4.95884 5.76563 4.9253 5.50982 4.98962 5.26973C5.05395 5.02963 5.21089 4.82485 5.426 4.70031ZM13.2894 20.9449C11.9108 21.7387 10.2737 21.9533 8.7372 21.5416C7.20066 21.1299 5.89016 20.1255 5.09319 18.7488L1.62444 12.7409C1.50012 12.5255 1.46644 12.2696 1.5308 12.0294C1.59517 11.7893 1.75231 11.5845 1.96766 11.4602C2.183 11.3358 2.43892 11.3022 2.6791 11.3665C2.91928 11.4309 3.12406 11.588 3.24838 11.8034L5.49838 15.7005C5.59854 15.8713 5.76222 15.9956 5.95369 16.0462C6.14516 16.0969 6.34888 16.0697 6.5204 15.9707C6.69191 15.8716 6.8173 15.7088 6.86919 15.5177C6.92108 15.3265 6.89526 15.1226 6.79738 14.9505L3.23488 8.77994C3.17235 8.67328 3.13153 8.5553 3.11478 8.43281C3.09803 8.31031 3.10568 8.18571 3.13728 8.06618C3.16889 7.94665 3.22382 7.83455 3.29892 7.73633C3.37402 7.63812 3.46781 7.55573 3.57488 7.49391C3.68195 7.43209 3.8002 7.39206 3.9228 7.37612C4.04541 7.36019 4.16996 7.36866 4.28928 7.40105C4.40859 7.43345 4.52033 7.48912 4.61804 7.56488C4.71575 7.64063 4.79752 7.73496 4.85863 7.84244L8.42113 14.013C8.52129 14.1838 8.68497 14.3081 8.87644 14.3587C9.06791 14.4094 9.27163 14.3822 9.44315 14.2832C9.61466 14.1841 9.74005 14.0213 9.79194 13.8302C9.84383 13.639 9.81801 13.4351 9.72013 13.263L6.90763 8.39153C6.84607 8.28491 6.80612 8.16721 6.79005 8.04514C6.77398 7.92308 6.78211 7.79905 6.81398 7.68012C6.84584 7.5612 6.90082 7.44972 6.97577 7.35205C7.05072 7.25437 7.14417 7.17242 7.2508 7.11086C7.35742 7.0493 7.47512 7.00935 7.59719 6.99328C7.71925 6.97721 7.84329 6.98535 7.96221 7.01721C8.20238 7.08157 8.40715 7.2387 8.53147 7.45403L12.469 14.274C12.5691 14.4448 12.7328 14.5691 12.9243 14.6197C13.1158 14.6704 13.3195 14.6432 13.491 14.5442C13.6625 14.4451 13.7879 14.2823 13.8398 14.0912C13.8917 13.9 13.8659 13.6961 13.768 13.524L12.268 10.926V10.9259C12.2064 10.8193 12.1665 10.7015 12.1504 10.5795C12.1343 10.4574 12.1425 10.3334 12.1743 10.2145C12.2387 9.97429 12.3958 9.76952 12.6111 9.6452C12.8265 9.52088 13.0824 9.4872 13.3225 9.55155C13.4415 9.58342 13.553 9.6384 13.6506 9.71335C13.7483 9.7883 13.8303 9.88175 13.8918 9.98838L15.4856 12.7488C16.2812 14.127 16.4967 15.7647 16.0849 17.3017C15.673 18.8388 14.6675 20.1493 13.2894 20.9449ZM17.7575 15.035C17.6553 13.9648 17.3235 12.9292 16.7847 11.9988L15.1908 9.23838C14.9617 8.83955 14.6237 8.51426 14.2164 8.3006L14.1161 8.12688C14.0535 8.02022 14.0127 7.90224 13.996 7.77974C13.9792 7.65725 13.9869 7.53265 14.0185 7.41312C14.0501 7.29358 14.105 7.18149 14.1801 7.08327C14.2552 6.98506 14.349 6.90267 14.4561 6.84085C14.5631 6.77903 14.6814 6.739 14.804 6.72306C14.9266 6.70713 15.0511 6.7156 15.1705 6.74799C15.2898 6.78039 15.4015 6.83606 15.4992 6.91181C15.5969 6.98757 15.6787 7.0819 15.7398 7.18938L17.3336 9.94985C17.772 10.7148 18.0372 11.5667 18.1104 12.4453C18.1837 13.324 18.0632 14.208 17.7575 15.035ZM14.5072 2.31128L14.8954 0.862471C14.9469 0.670334 15.0726 0.506527 15.2449 0.407086C15.4172 0.307645 15.6219 0.280715 15.8141 0.332221C16.0062 0.383727 16.17 0.509449 16.2694 0.681731C16.3689 0.854012 16.3958 1.05874 16.3443 1.25088L15.9561 2.69969C15.9306 2.79483 15.8866 2.88401 15.8266 2.96214C15.7667 3.04028 15.6919 3.10584 15.6066 3.15507C15.5213 3.20431 15.4271 3.23627 15.3295 3.24911C15.2318 3.26196 15.1326 3.25544 15.0374 3.22994C14.9423 3.20444 14.8531 3.16044 14.775 3.10048C14.6968 3.04051 14.6313 2.96573 14.5821 2.88043C14.4826 2.70815 14.4557 2.50342 14.5072 2.31128ZM16.978 3.17613L17.8384 1.94735C17.8945 1.86564 17.9662 1.79585 18.0494 1.74202C18.1326 1.68819 18.2256 1.65138 18.3231 1.63372C18.4206 1.61605 18.5207 1.61789 18.6175 1.63911C18.7143 1.66034 18.8059 1.70053 18.887 1.75738C18.9682 1.81422 19.0373 1.88659 19.0903 1.9703C19.1434 2.054 19.1793 2.14739 19.196 2.24506C19.2128 2.34273 19.21 2.44275 19.1878 2.53934C19.1657 2.63592 19.1246 2.72716 19.067 2.80778L18.2066 4.03656C18.0916 4.19739 17.9178 4.30634 17.723 4.33972C17.5282 4.3731 17.328 4.32821 17.1661 4.21481C17.0042 4.10142 16.8936 3.92868 16.8584 3.73418C16.8231 3.53967 16.8661 3.33912 16.978 3.17613ZM21.0931 5.20206L19.8643 6.0625C19.7014 6.17435 19.5008 6.21733 19.3063 6.18209C19.1118 6.14685 18.9391 6.03625 18.8257 5.87434C18.7123 5.71243 18.6674 5.51229 18.7008 5.31746C18.7341 5.12262 18.8431 4.94884 19.0039 4.83391L20.2327 3.97347C20.3133 3.91585 20.4045 3.87478 20.5011 3.85264C20.5977 3.83049 20.6977 3.8277 20.7954 3.84443C20.8931 3.86117 20.9865 3.89709 21.0702 3.95012C21.1539 4.00316 21.2262 4.07226 21.2831 4.15343C21.3399 4.23459 21.3801 4.32622 21.4014 4.42301C21.4226 4.51981 21.4244 4.61985 21.4068 4.71735C21.3891 4.81486 21.3523 4.9079 21.2984 4.9911C21.2446 5.07429 21.1748 5.146 21.0931 5.20206Z"
                fill={fill}
            />
        </svg>
    );
};

export const StockIcon = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.2025 9L21.5619 7.38281L14.9058 14.0625C14.8277 14.2812 14.7184 14.4609 14.5777 14.6016C14.2652 14.9141 13.8824 15.0391 13.4293 14.9766C13.0231 14.9922 12.6793 14.8594 12.3981 14.5781C12.2575 14.4531 12.1559 14.2891 12.0934 14.0859L11.2263 13.2188C11.195 13.2656 10.7692 13.7383 9.94895 14.6367C9.12866 15.5352 8.67945 16.0234 8.60133 16.1016C8.28884 16.4141 7.89822 16.5391 7.42949 16.4766C7.02325 16.4922 6.67951 16.3594 6.39826 16.0781C6.25764 15.9531 6.15608 15.7891 6.09359 15.5859L5.9764 15.4688L3.1171 18.3281C3.10148 18.3438 3.08195 18.3594 3.05851 18.375C3.03507 18.3906 3.01554 18.4062 2.99992 18.4219V21H22.4994C22.9056 21 23.2572 21.1484 23.5541 21.4453C23.8509 21.7422 23.9994 22.0977 23.9994 22.5117C23.9994 22.9258 23.8509 23.2773 23.5541 23.5664C23.2572 23.8555 22.9056 24 22.4994 24H1.49996C1.0781 24 0.722637 23.8555 0.433582 23.5664C0.144527 23.2773 0 22.9219 0 22.5V1.5C0 1.09375 0.144527 0.742188 0.433582 0.445312C0.722637 0.148438 1.07419 0 1.48824 0C1.90229 0 2.25775 0.148438 2.55462 0.445312C2.85149 0.742188 2.99992 1.09375 2.99992 1.5V14.5078L4.59363 12.9141C4.65612 12.7266 4.75768 12.5625 4.8983 12.4219C5.17955 12.1406 5.52329 12.0078 5.92953 12.0234C6.38264 11.9766 6.76544 12.1016 7.07793 12.3984C7.21855 12.5391 7.32793 12.7266 7.40605 12.9609L7.47636 13.0312L9.84348 10.6641C9.90598 10.4766 10.0075 10.3125 10.1482 10.1719C10.4294 9.89062 10.7731 9.75781 11.1794 9.77344C11.6481 9.72656 12.0309 9.85156 12.3278 10.1484C12.4684 10.2891 12.5778 10.4766 12.6559 10.7109L13.4762 11.5312L19.5932 5.41406L17.9995 3.82031C17.9839 3.25781 18.1558 2.98438 18.5151 3H23.2494C23.4681 3.01562 23.6439 3.08984 23.7767 3.22266C23.9095 3.35547 23.9837 3.53125 23.9994 3.75V8.48438C24.015 8.85938 23.7494 9.03125 23.2025 9Z"
                fill={fill}
            />
        </svg>
    );
};

export const LeaksIcon = ({
    className = '',
    height = 18,
    width = 25,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 0L0 4.4835V15.033C3.55683e-08 17.4199 0.948211 19.7091 2.63604 21.397C4.32387 23.0848 6.61305 24.033 9 24.033C11.3869 24.033 13.6761 23.0848 15.364 21.397C17.0518 19.7091 18 17.4199 18 15.033V4.4835L9 0ZM14.1225 20.4855L9 17.934V19.605L12.777 21.4867C11.6391 22.1495 10.3468 22.5011 9.03004 22.5061C7.71323 22.5111 6.41831 22.1694 5.27542 21.5153C4.13253 20.8613 3.18195 19.9179 2.51922 18.78C1.8565 17.6421 1.50498 16.3498 1.5 15.033V5.4075L9 1.671L16.5 5.4075V8.22L9 4.4835V6.1545L16.5 9.891V12.7035L9 8.967V10.638L16.5 14.3745V15.033C16.5003 15.7143 16.407 16.3924 16.2225 17.0483L9 13.4505V15.1215L15.6713 18.4447C15.2755 19.2086 14.7517 19.8989 14.1225 20.4855Z"
                fill={fill}
            />
        </svg>
    );
};

export const SprintInsightsIcon = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.5 19.5C17.3284 19.5 18 18.8284 18 18C18 17.1716 17.3284 16.5 16.5 16.5C15.6716 16.5 15 17.1716 15 18C15 18.8284 15.6716 19.5 16.5 19.5Z"
                fill={fill}
            />
            <path
                d="M22.3328 17.6093C21.8693 16.4287 21.0697 15.41 20.0329 14.6796C18.9961 13.9491 17.7677 13.539 16.5 13.5C15.2323 13.539 14.0039 13.9491 12.9671 14.6796C11.9303 15.41 11.1307 16.4287 10.6672 17.6093L10.5 18L10.6672 18.3907C11.1307 19.5713 11.9303 20.59 12.9671 21.3204C14.0039 22.0509 15.2323 22.461 16.5 22.5C17.7677 22.461 18.9961 22.0509 20.0329 21.3204C21.0697 20.59 21.8693 19.5713 22.3328 18.3907L22.5 18L22.3328 17.6093ZM16.5 21C15.9067 21 15.3266 20.8241 14.8333 20.4944C14.3399 20.1648 13.9554 19.6962 13.7284 19.148C13.5013 18.5999 13.4419 17.9967 13.5576 17.4147C13.6734 16.8328 13.9591 16.2982 14.3787 15.8787C14.7982 15.4591 15.3328 15.1734 15.9147 15.0576C16.4967 14.9419 17.0999 15.0013 17.648 15.2284C18.1962 15.4554 18.6648 15.8399 18.9944 16.3333C19.3241 16.8266 19.5 17.4067 19.5 18C19.499 18.7953 19.1826 19.5578 18.6202 20.1202C18.0578 20.6826 17.2953 20.999 16.5 21Z"
                fill={fill}
            />
            <path
                d="M9 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V12H20.25V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H9V21ZM9 3H15V6H9V3Z"
                fill={fill}
            />
        </svg>
    );
};

export const SREIcon = ({
    className = '',
    height = 20,
    width = 20,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 8V16H18V8H20ZM18 18V20H20V18H18ZM16 15.29C15.2498 16.142 14.3267 16.8244 13.2921 17.2917C12.2575 17.759 11.1352 18.0005 10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2V11L17.55 3.45C16.6135 2.36608 15.4542 1.4968 14.1513 0.901438C12.8484 0.306073 11.4325 -0.00139026 10 4.72568e-06C4.48 4.72568e-06 0 4.48 0 10C0 15.52 4.48 20 10 20C12.25 20 14.33 19.26 16 18V15.29Z"
                fill={fill}
            />
        </svg>
    );
};

export const HoursIcon = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z"
                fill={fill}
            />
            <path
                d="M13 7H11V12.414L14.293 15.707L15.707 14.293L13 11.586V7Z"
                fill={fill}
            />
        </svg>
    );
};

export const SettingsIcon = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            className={className}
            height={height}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.827 24H9.45903C9.18534 24 8.91987 23.9065 8.70663 23.735C8.49339 23.5634 8.34519 23.3241 8.28663 23.0568L7.79822 20.796C7.1467 20.5105 6.52891 20.1535 5.95623 19.7316L3.75183 20.4336C3.4909 20.5168 3.20936 20.5083 2.95397 20.4094C2.69857 20.3105 2.48469 20.1272 2.34783 19.89L0.159025 16.1088C0.0235997 15.8714 -0.0272357 15.595 0.0148361 15.3249C0.0569079 15.0548 0.189396 14.807 0.390625 14.622L2.10063 13.062C2.02286 12.3553 2.02286 11.6423 2.10063 10.9356L0.390625 9.3792C0.189111 9.19413 0.0564427 8.94609 0.014364 8.67574C-0.0277147 8.40539 0.0232924 8.12876 0.159025 7.8912L2.34303 4.1076C2.47989 3.87038 2.69377 3.68711 2.94917 3.58823C3.20457 3.48934 3.4861 3.48079 3.74703 3.564L5.95143 4.266C6.24423 4.05 6.54903 3.8484 6.86343 3.666C7.16703 3.4956 7.47902 3.3408 7.79822 3.2028L8.28783 0.9444C8.34611 0.677037 8.49402 0.437625 8.70704 0.265859C8.92006 0.0940918 9.18538 0.000287959 9.45903 0H13.827C14.1007 0.000287959 14.366 0.0940918 14.579 0.265859C14.792 0.437625 14.9399 0.677037 14.9982 0.9444L15.4926 3.204C16.1438 3.48948 16.7612 3.84647 17.3334 4.2684L19.539 3.5664C19.7998 3.4835 20.0811 3.4922 20.3362 3.59107C20.5913 3.68994 20.805 3.87304 20.9418 4.11L23.1258 7.8936C23.4042 8.382 23.3082 9 22.8942 9.3804L21.1842 10.9404C21.262 11.6471 21.262 12.3601 21.1842 13.0668L22.8942 14.6268C23.3082 15.0084 23.4042 15.6252 23.1258 16.1136L20.9418 19.8972C20.805 20.1344 20.5911 20.3177 20.3357 20.4166C20.0803 20.5155 19.7987 20.524 19.5378 20.4408L17.3334 19.7388C16.7612 20.1604 16.1438 20.517 15.4926 20.802L14.9982 23.0568C14.9397 23.3239 14.7917 23.5631 14.5787 23.7346C14.3657 23.9061 14.1005 23.9998 13.827 24ZM6.38703 17.0748L7.37102 17.7948C7.59302 17.958 7.82343 18.108 8.06343 18.2448C8.28903 18.3756 8.51943 18.4932 8.75823 18.6L9.87783 19.0908L10.4262 21.6H12.8622L13.4106 19.0896L14.5302 18.5988C15.0186 18.3828 15.483 18.1152 15.9138 17.7996L16.8978 17.0796L19.3482 17.8596L20.5662 15.75L18.6666 14.0184L18.801 12.804C18.861 12.2724 18.861 11.736 18.801 11.2056L18.6666 9.9912L20.5674 8.256L19.3482 6.1452L16.899 6.9252L15.9138 6.2052C15.4828 5.88803 15.0189 5.61808 14.5302 5.4L13.4106 4.9092L12.8622 2.4H10.4262L9.87423 4.9104L8.75823 5.4C8.26885 5.61433 7.8048 5.88237 7.37463 6.1992L6.38943 6.9192L3.94143 6.1392L2.72103 8.256L4.62063 9.9852L4.48623 11.2008C4.42623 11.7324 4.42623 12.2688 4.48623 12.7992L4.62063 14.0136L2.72103 15.7452L3.93903 17.8548L6.38703 17.0748ZM11.6382 16.8C10.3652 16.8 9.14429 16.2943 8.24411 15.3941C7.34394 14.4939 6.83822 13.273 6.83822 12C6.83822 10.727 7.34394 9.50606 8.24411 8.60589C9.14429 7.70571 10.3652 7.2 11.6382 7.2C12.9113 7.2 14.1322 7.70571 15.0323 8.60589C15.9325 9.50606 16.4382 10.727 16.4382 12C16.4382 13.273 15.9325 14.4939 15.0323 15.3941C14.1322 16.2943 12.9113 16.8 11.6382 16.8ZM11.6382 9.6C11.1683 9.60048 10.7088 9.73893 10.3168 9.99817C9.92476 10.2574 9.6175 10.6261 9.43311 11.0583C9.24871 11.4906 9.19529 11.9675 9.27948 12.4299C9.36366 12.8923 9.58175 13.3198 9.90668 13.6593C10.2316 13.9989 10.6491 14.2355 11.1073 14.34C11.5655 14.4444 12.0443 14.412 12.4843 14.2468C12.9243 14.0816 13.3061 13.7909 13.5823 13.4107C13.8585 13.0305 14.0171 12.5775 14.0382 12.108V12.588V12C14.0382 11.3635 13.7854 10.753 13.3353 10.3029C12.8852 9.85286 12.2747 9.6 11.6382 9.6Z"
                fill={fill}
            />
        </svg>
    );
};

export const CreateOrganisation = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={height}
            viewBox="0 0 24 24"
            width={width}
            fill={fill}
        >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
        </svg>
    );
};

export const TeamsIcon = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={fill}
        >
            <g>
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M12 11a5 5 0 0 1 5 5v6H7v-6a5 5 0 0 1 5-5zm-6.712 3.006a6.983 6.983 0 0 0-.28 1.65L5 16v6H2v-4.5a3.5 3.5 0 0 1 3.119-3.48l.17-.014zm13.424 0A3.501 3.501 0 0 1 22 17.5V22h-3v-6c0-.693-.1-1.362-.288-1.994zM5.5 8a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM12 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" />
            </g>
        </svg>
    );
};

export const SuperadminIcon = ({
    className = '',
    height = 24,
    width = 24,
    isActive = false,
    hovered = false,
}) => {
    let fill = '#DADDE8';
    if (!isActive) {
        hovered ? (fill = '#D6DA33') : (fill = '#DADDE8');
    } else {
        fill = '#D6DA33';
    }
    return (
        <svg
            fill={fill}
            height={height}
            width={width}
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 474.565 474.565"
            xmlSpace="preserve"
        >
            <g>
                <path d="M255.204,102.3c-0.606-11.321-12.176-9.395-23.465-9.395C240.078,95.126,247.967,98.216,255.204,102.3z" />
                <path
                    d="M134.524,73.928c-43.825,0-63.997,55.471-28.963,83.37c11.943-31.89,35.718-54.788,66.886-63.826
		C163.921,81.685,150.146,73.928,134.524,73.928z"
                />
                <path
                    d="M43.987,148.617c1.786,5.731,4.1,11.229,6.849,16.438L36.44,179.459c-3.866,3.866-3.866,10.141,0,14.015l25.375,25.383
		c1.848,1.848,4.38,2.888,7.019,2.888c2.61,0,5.125-1.04,7.005-2.888l14.38-14.404c2.158,1.142,4.55,1.842,6.785,2.827
		c0-0.164-0.016-0.334-0.016-0.498c0-11.771,1.352-22.875,3.759-33.302c-17.362-11.174-28.947-30.57-28.947-52.715
		c0-34.592,28.139-62.739,62.723-62.739c23.418,0,43.637,13.037,54.43,32.084c11.523-1.429,22.347-1.429,35.376,1.033
		c-1.676-5.07-3.648-10.032-6.118-14.683l14.396-14.411c1.878-1.856,2.918-4.38,2.918-7.004c0-2.625-1.04-5.148-2.918-7.004
		l-25.361-25.367c-1.94-1.941-4.472-2.904-7.003-2.904c-2.532,0-5.063,0.963-6.989,2.904l-14.442,14.411
		c-5.217-2.764-10.699-5.078-16.444-6.825V9.9c0-5.466-4.411-9.9-9.893-9.9h-35.888c-5.451,0-9.909,4.434-9.909,9.9v20.359
		c-5.73,1.747-11.213,4.061-16.446,6.825L75.839,22.689c-1.942-1.941-4.473-2.904-7.005-2.904c-2.531,0-5.077,0.963-7.003,2.896
		L36.44,48.048c-1.848,1.864-2.888,4.379-2.888,7.012c0,2.632,1.04,5.148,2.888,7.004l14.396,14.403
		c-2.75,5.218-5.063,10.708-6.817,16.438H23.675c-5.482,0-9.909,4.441-9.909,9.915v35.889c0,5.458,4.427,9.908,9.909,9.908H43.987z"
                />
                <path
                    d="M354.871,340.654c15.872-8.705,26.773-25.367,26.773-44.703c0-28.217-22.967-51.168-51.184-51.168
		c-9.923,0-19.118,2.966-26.975,7.873c-4.705,18.728-12.113,36.642-21.803,52.202C309.152,310.022,334.357,322.531,354.871,340.654z
		"
                />
                <path
                    d="M460.782,276.588c0-5.909-4.799-10.693-10.685-10.693H428.14c-1.896-6.189-4.411-12.121-7.393-17.75l15.544-15.544
		c2.02-2.004,3.137-4.721,3.137-7.555c0-2.835-1.118-5.553-3.137-7.563l-27.363-27.371c-2.08-2.09-4.829-3.138-7.561-3.138
		c-2.734,0-5.467,1.048-7.547,3.138l-15.576,15.552c-5.623-2.982-11.539-5.481-17.751-7.369v-21.958
		c0-5.901-4.768-10.685-10.669-10.685H311.11c-2.594,0-4.877,1.04-6.739,2.578c3.26,11.895,5.046,24.793,5.046,38.552
		c0,8.735-0.682,17.604-1.956,26.423c7.205-2.656,14.876-4.324,22.999-4.324c36.99,0,67.086,30.089,67.086,67.07
		c0,23.637-12.345,44.353-30.872,56.303c13.48,14.784,24.195,32.324,31.168,51.976c1.148,0.396,2.344,0.684,3.54,0.684
		c2.733,0,5.467-1.04,7.563-3.13l27.379-27.371c2.004-2.004,3.106-4.721,3.106-7.555s-1.102-5.551-3.106-7.563l-15.576-15.552
		c2.982-5.621,5.497-11.555,7.393-17.75h21.957c2.826,0,5.575-1.118,7.563-3.138c2.004-1.996,3.138-4.72,3.138-7.555
		L460.782,276.588z"
                />
                <path
                    d="M376.038,413.906c-16.602-48.848-60.471-82.445-111.113-87.018c-16.958,17.958-37.954,29.351-61.731,29.351
		c-23.759,0-44.771-11.392-61.713-29.351c-50.672,4.573-94.543,38.17-111.145,87.026l-9.177,27.013
		c-2.625,7.773-1.368,16.338,3.416,23.007c4.783,6.671,12.486,10.631,20.685,10.631h315.853c8.215,0,15.918-3.96,20.702-10.631
		c4.767-6.669,6.041-15.234,3.4-23.007L376.038,413.906z"
                />
                <path
                    d="M120.842,206.782c0,60.589,36.883,125.603,82.352,125.603c45.487,0,82.368-65.014,82.368-125.603
		C285.563,81.188,120.842,80.939,120.842,206.782z"
                />
            </g>
        </svg>
    );
};

